import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['Boards and lists of ideas you still have to turn into a meeting', 'Written for experts, not a parent who’s rusty on knots', 'One activity per page — you still fill the other 60 minutes', 'No plan B when it rains or half the group is missing', 'Every week starts from zero again'];
const withIt = ['60 complete meetings, start to finish', 'Every skill explained to you first, in plain words', 'Five timed blocks for 45, 60 or 90 minutes', 'A Rain Swap indoor twin in every meeting', 'Ten minutes the night before and you’re ready'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="topo-light w-full bg-paper" data-id="element-303" data-mp="295e7b2ylqnqg">
      <div className="mx-auto max-w-4xl px-5 py-14 sm:py-20" data-id="element-304" data-mp="2d6pqapmz0apo">
        <div className="text-center" data-id="element-305" data-mp="30xbxyft2bsz5">
          <p className="eyebrow text-ember-deep" data-id="element-306" data-mp="30wacriic1q3p">
            Why this isn&apos;t another idea list
          </p>
          <h2 id="vs-heading" className="trail-underline mt-3 font-display text-[30px] leading-tight text-pine sm:text-5xl" data-id="element-307" data-mp="1tfcwex493bvn">
            Activity ideas vs{' '}
            <span className="text-forest" data-id="element-308" data-mp="1oefg6q2swrws">a planned year</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-pine-soft" data-id="element-309" data-mp="236hcy19kr4sl">
            Yes, your organization has activity finders and there are thousands
            of ideas online. Finding ideas was never the hard part — turning
            them into a 90-minute night that runs itself is. That’s the part
            this does for you.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-2xl border border-paper-dark shadow-card" data-id="element-310" data-mp="2m2za4y76zww8">
          <div className="bg-signal px-3.5 py-4 text-white sm:p-6" data-id="element-311" data-mp="2h68ta8nkcx9r">
            <span className="font-display text-2xl leading-none sm:text-3xl" data-id="element-312" data-mp="rphnddem3429">
              Ideas
            </span>
            <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-white/85 sm:text-[11px]" data-id="element-313" data-mp="mry6e5qj4d6m">
              Pinterest &amp; free lists
            </p>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-314" data-mp="2rrz74k2dhvs6">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[13px] leading-snug text-white/95 sm:text-sm" data-id="element-315" data-mp="2vtu97qs4od70">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-white/20" data-id="element-316" data-mp="30u8fb3a65d2e">
                    <XIcon className="h-2.5 w-2.5 text-white" aria-hidden="true" data-id="element-317" data-mp="3ar4tnpmr0tev" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-forest px-3.5 py-4 text-white sm:p-6" data-id="element-318" data-mp="3jjf51a9dr4xp">
            <span className="font-display text-2xl leading-none sm:text-3xl" data-id="element-319" data-mp="3jin89w41r15u">
              Meetings
            </span>
            <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-ember sm:text-[11px]" data-id="element-320" data-mp="3ogoq6dpqkufq">
              Troop Night Ready
            </p>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-321" data-mp="7h6nbp7vln5s">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[13px] font-medium leading-snug sm:text-sm" data-id="element-322" data-mp="2gspezzzntlh">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-moss" data-id="element-323" data-mp="3plrwyfj07ozc">
                    <CheckIcon className="h-2.5 w-2.5 text-pine" aria-hidden="true" data-id="element-324" data-mp="q76a25g8uq61" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}